import { GoogleWindow } from './auth.types';

const GIS_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';

let googleScriptPromise: Promise<void> | null = null;

export const loadGoogleScript = (): Promise<void> => {
  if (googleScriptPromise) {
    return googleScriptPromise;
  }

  googleScriptPromise = new Promise((resolve, reject) => {
    const googleWindow = window as GoogleWindow;
    if (googleWindow.google?.accounts?.oauth2) {
      resolve();

      return;
    }

    const existingScript = document.querySelector(`script[src="${GIS_SCRIPT_SRC}"]`);
    if (existingScript) {
      if (googleWindow.google?.accounts?.oauth2) {
        resolve();

        return;
      }

      existingScript.addEventListener('load', () => resolve());
      existingScript.addEventListener('error', () => reject(new Error('Failed to load Google Sign-In')));

      return;
    }

    const script = document.createElement('script');
    script.src = GIS_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Sign-In'));
    document.head.appendChild(script);
  });

  return googleScriptPromise;
};
